import { Model } from "@type-r/models";
import { useMemo } from "react";
import { MultiSelectFilter } from "./filters/multiselect-filter";


export const useLabels = (filter: Model) => {
    const { displayLabels } = filter.constructor as any;
    return useMemo(() =>
        filter.mapObject((_, key) => {
            const displayLabel = displayLabels && displayLabels[key];
            if (displayLabel) return displayLabel;

            const x = key.replace(/([A-Z])/g, " $1");
            return x.charAt(0).toUpperCase() + x.slice(1);
        })
        , [filter.constructor]);
}

export const filterByMultiSelect = (multiSelect: MultiSelectFilter, value): boolean => {
    return !multiSelect || !multiSelect.selected || !multiSelect.selected.length
        || multiSelect.selected.includes(value);
}